module.exports = __webpack_public_path__ + "ab6aaf405ce5ae0fa8cb6782f82599d4.fbx";